export const ETL_AUDIT_ENTITY_NAME = 'ext.load.module.audit.etl.process';
export const SUCCESSFULLY_UPLOADED = 'SUCCESSFULLY_UPLOADED';
